import { DefaultButton, IButtonStyles, PrimaryButton } from "@fluentui/react";
import React from "react";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { defaultButtonStyles, lgDefaultButtonStyles, lgPrimaryButtonStyles, mdDefaultButtonStyles, mdPrimaryButtonStyles, primaryButtonStyles, smDefaultButtonStyles, smPrimaryButtonStyles, xlDefaultButtonStyles, xlPrimaryButtonStyles, xxlDefaultButtonStyles, xxlPrimaryButtonStyles } from "./Styles/RegisterButtonStyles";

export interface IRegisterButtonProps {
    iconName: string;
    text: string;
    infoText: string;
    subtitle?: string;
    disabled?: boolean;
    styles?: IButtonStyles | undefined
    onClick: () => void;
}

export const RegisterPrimaryButton: React.FC<IRegisterButtonProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <PrimaryButton
            styles={
                props.styles ? 
                props.styles 
                : 
                    isSM ? 
                        smPrimaryButtonStyles : 
                    isMD ? 
                        mdPrimaryButtonStyles :
                    isLG ?
                        lgPrimaryButtonStyles :
                    isXL ?
                        xlPrimaryButtonStyles :
                    isXXL ?
                        xxlPrimaryButtonStyles
                    :
                        primaryButtonStyles
            }
            iconProps={{ iconName: props.iconName }}
            disabled={props.disabled}
            onClick={() => props.onClick()}
        >
            {props.text}
        </PrimaryButton>
    );
};

export const RegisterSecondaryButton: React.FC<IRegisterButtonProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <DefaultButton
            styles={
                props.styles ? 
                props.styles 
                : 
                    isSM ? 
                        smDefaultButtonStyles : 
                    isMD ? 
                        mdDefaultButtonStyles :
                    isLG ?
                        lgDefaultButtonStyles :
                    isXL ?
                        xlDefaultButtonStyles :
                    isXXL ?
                        xxlDefaultButtonStyles
                    :
                        defaultButtonStyles
            }
            iconProps={{ iconName: props.iconName }}
            onClick={() => props.onClick()}
        >
            {props.text}
        </DefaultButton>
    );
};